module.exports = __webpack_public_path__ + "alska_bg_second_374x260.574c3b8.jpg";